export default __webpack_public_path__ + "static/media/33.7051bcff.jpg";